import React, { useEffect, useState } from 'react';
import colors from '../../../Utils/colors';
import { Form, InputGroup } from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import images from '../../../Utils/images';
import { useNavigate } from 'react-router-dom';
import { AiFillEyeInvisible, AiFillEye, AiOutlineInfoCircle } from 'react-icons/ai';
import { eventsend } from '../../../Config/analyticsFunctions';
import { MdOutlineOpenInNew } from 'react-icons/md';
import { trackEvent } from '../../../Services';
import { Button, CircularProgress, TextField } from '@mui/material';
import PasswordField from './PasswordField';

export default function NewAuthLogin({
  loginAction,
  googleloginaction,
  agentLogin,
  setAgentLogin,
  password,
  setPassword,
  newLoginAction,
  passwordAction,
  setIsOpen,
  facebookId,
  setFacebookId,
  invalidCredentials,
  btnDisabled,
  // incorrectEmail
  // EETrial,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const toggle = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    eventsend('login_pageview_web');
  }, []);

  const token = localStorage.getItem('token');
  useEffect(() => {
    if (token) {
      navigate('/creator');
    }
  }, [token]);

  const onClickForgot = () => {
    //onClick={() => passwordAction(true) && loginAction(false) && setIsOpen(true)}
    passwordAction(true);
    setIsOpen(true);
  };

  const newLogin = () => {
    //  loginAction();
    eventsend('Login_Login_page_clicked');
    newLoginAction();
  };

  const handleTrackEvent = async (event) => {
    if (facebookId !== 'priam@cheerio.in') {
      try {
        const data = {
          email: 'facebookId@cheerio.in',
          event: event,
          properties: {
            userInput: facebookId,
          },
        };
        const response = await trackEvent(data);
        if (response?.flag) {
          localStorage.setItem('login_event', 'true');
          console.log('event tracked successfully');
        } else {
          console.log('error in track event');
        }
      } catch (error) {
        console.log('error in track event', error);
      }
    }
  };

  return (
    <div className="auth_authlogin">
      {/* <form
                onSubmit={(e) => {
                    e.preventDefault();
                    newLogin();
                }}
            > */}
      <div className="auth_authlogin__body">
        <form
          className="Column form_flex"
          style={{}}
          onSubmit={(e) => {
            handleTrackEvent('login_button_clicked');
            e.preventDefault();
            eventsend('Login_button_login_page_clicked');
            newLogin();
          }}
        >
          <div className="Column w-100 justify-content-start align-items-start my-2">
            {/* Login text -- upper */}
            <img
              src={images.OBLogoText}
              style={{
                height: 40,
                width: 'auto',
                objectFit: 'contain',
                marginBlockEnd: 16,
              }}
            />
            <div className="row_1">
              <h2>{'Login'}</h2>
            </div>

            {/* Form check -- upper */}
            <div
              className=""
              style={{
                justifyContent: 'left',
                paddingInline: 10,
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                flexDirection: 'row',
                fontWeight: 400,
                color: colors.black,
                cursor: 'pointer',
                margin: 0,
                padding: 0,
                marginTop: '5%',
              }}
            >
              <Form.Check // prettier-ignore
                inline
                type={'radio'}
                id={`radio-Owner`}
                label={`Admin`}
                style={{ marginInlineEnd: 20, padding: 5, marginLeft: '6%' }}
                checked={!agentLogin}
                onChange={() => {
                  setAgentLogin(false);
                  eventsend('admin_login_page_selected');
                }}
              />
              <Form.Check // prettier-ignore
                inline
                type={'radio'}
                id={`radio-Agent`}
                label={`Agent`}
                style={{ marginInlineEnd: 20, padding: 5, marginLeft: '6%' }}
                checked={agentLogin}
                onChange={() => {
                  setAgentLogin(true);
                  eventsend('agent_login_page_selected');
                }}
              />
            </div>

            <div className="d-flex flex-column justify-content-between align-items-center w-100">
              {/* Username Field -- upper */}
              <div className="my-3 form-group" style={{ width: '100%' }}>
                {/* <h6
                className="form-label"
                style={{ fontSize: 16, fontWeight: 600, color: colors.black }}
              >
                {agentLogin && 'Email'}
                {!agentLogin && 'Email / Contact'}
              </h6>
              <input
                className="form-control"
                placeholder="Enter here"
                id="FacebookId"
                value={facebookId}
                onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/\s/g, '');
                  setFacebookId(sanitizedValue);
                  eventsend("Email/Phone_login_page_entered");
                }}
              /> */}
                <TextField
                  id="login-email"
                  type={agentLogin ? 'email' : 'text'}
                  placeholder={agentLogin ? 'Email Id' : 'Email / Contact'}
                  value={facebookId}
                  onChange={(e) => {
                    const sanitizedValue = (e.target.value || '').replace(/\s/g, '');
                    setFacebookId(sanitizedValue);
                    eventsend('Email/Phone_login_page_entered');
                  }}
                  fullWidth
                  variant="outlined"
                  size="small"
                  inputProps={{ inputMode: agentLogin ? 'email' : 'text' }}
                />
              </div>

              {/* Password Field -- upper */}
              <div className="my-3 form-group" style={{ width: '100%' }}>
                {/* <h6
                style={{ fontSize: 16, fontWeight: 600, color: colors.black }}
                className="form-label"
              >
                Password
              </h6>
              <div
                className=""
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  // marginTop: "auto",
                }}
              >
                <input
                  type={showPassword ? 'text' : 'password'}
                  style={{}}
                  className="form-control"
                  id="UserPassword"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => {
                  const sanitizedValue = e.target.value.replace(/\s/g, '');
                    setPassword(sanitizedValue)
                    eventsend("Password_login_page_entered")
                  }}
                  minLength={8}
                />
                <span
                  className="icon"
                  style={{ marginLeft: '-10%', marginTop: '1%' }}
                  onClick={toggle}
                >
                  {showPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                </span>
              </div> */}
                <PasswordField
                  password={password}
                  setPassword={setPassword}
                  eventsend={eventsend}
                  analyticsEvent="Password_login_page_entered"
                  autoComplete="current-password"
                  stripWhitespace
                  minLength={8}
                />

                {/* Invalid cred -- upper */}
                <div className="send_otp_container__sub">
                  <p className="incorrect_otp">{invalidCredentials && 'Invalid credentials. Please try again.'}</p>
                </div>

                {/* Forgot password -- upper */}
                <div
                  className=""
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    // marginTop: "auto",
                  }}
                >
                  {/* Forgot Password */}
                  <div className="Row w-100 justify-content-end my-3">
                    <p style={{ color: colors.linkblue, cursor: 'pointer' }} onClick={onClickForgot}>
                      {'Forgot Password?'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="Column w-100 justify-content-start my-2">
            <div className="body_form__button_container">
              <Button
                onClick={() => {
                  handleTrackEvent('login_button_clicked');
                  eventsend('Login_button_login_page_clicked');
                  newLogin();
                }}
                disabled={btnDisabled}
                fullWidth
                variant="contained"
              >
                {btnDisabled ? <CircularProgress size={20} /> : 'Login'}
              </Button>
              {/* <button
                style={{ width: '100%', borderWidth: 0, height: 40, marginTop: '5%', backgroundColor: colors.primary03, color: colors.white01 }}
                type="submit"
                className="btn"
              >
                Login
              </button> */}
            </div>
            <div className="start_trial" style={{}}>
              <p>
                {'Don’t have an account? '}
                <span onClick={() => loginAction()} style={{ color: colors.linkblue, cursor: 'pointer' }}>
                  {'Create Account'}
                </span>
              </p>
            </div>
          </div>
        </form>
      </div>
      {/* </form> */}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 30,
    justifyContent: 'right',
    width: '100%',
    paddingRight: 20,
    marginTop: 10,
  },
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // justifyItems: "center",
    justifyContent: 'space-evenly',
    width: '100%',
    // marginTop: 30,
    paddingLeft: '25%',
    paddingRight: '25%',
    height: '100%',
  },
  row: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    // marginTop: "10%",
  },
  forgotPass: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    // marginTop: "10%",
  },
  buttonStyle: {
    height: 40,
    // borderWidth: 1,
    // borderStyle: "solid",
    // borderColor: colors.white,
    borderRadius: 8,
    backgroundColor: colors.primary03,
    // display: "inline-block",
    fontSize: 16,
    fontWeight: 600,
    color: colors.black04,
    borderWidth: 1,
    width: '100%',
    backgroundColor: colors.white,
    borderColor: colors.greys01,
    // marginTop: 20,
    // marginBlockStart:20,
  },
  haveAc: {
    margin: 0,
    fontSize: 16,
    color: colors.darkgrey,
    marginLeft: 'auto',
    alignSelf: 'flex-end',
  },
  loginViaEmail: {
    fontSize: 12,
    padding: 5,
    paddingRight: 12,
    paddingLeft: 12,
    borderRadius: 8,
    color: colors.linkblue,
    marginLeft: 'auto',
    borderWidth: 0,
    backgroundColor: colors.white,
  },
  freeTrial: {
    margin: 0,
    padding: 0,
    fontSize: 22,
    color: colors.black,
    fontWeight: 700,
  },
};
